import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Links";
import SevenDS from "./pages/7ds";
import Character from "./pages/Character";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/7ds" element={<SevenDS />} />
        <Route path="/7ds/:character" element={<Character />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
